module.exports = __webpack_public_path__ + "img/p29592.478d26de.jpg";